import {Icon} from "@chakra-ui/react";
import {UserGroupIcon} from "@heroicons/react/20/solid";
import {Avatar, AvatarProps} from "./ui/avatar.tsx";

export type AvatarSize = "2xs" | "xs" | "sm" | "md" | "lg" | "xl" | "2xl";

const TeamAvatar = ({
  isMember,
  size,
  ...props
}: {isMember?: boolean; size?: AvatarSize} & Omit<AvatarProps, "size">) => {
  return (
    <Avatar
      // The glyph inherits the avatar's own colour, so a caller recolouring one recolours both.
      fallback={<Icon as={UserGroupIcon} boxSize="1.4em" />}
      bg={isMember ? "green.solid" : undefined}
      color={isMember ? "white" : "fg.muted"}
      size={size}
      {...props}
    />
  );
};

export default TeamAvatar;
